<template>
  <div id="vinculo-acompanhamento-recursos">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Recursos"
            description=""
            url="/vinculo-acompanhamento"
          />
        </div>
      </div>
      <ValidationObserver ref="observer" class="row">
        <div class="row form">
          <div class="col-lg-12">
            <label for="">Quantidade de equipes</label>
            <table class="table table-responsive table-striped">
              <thead class="thead-light">
                <tr>
                  <th>Equipe</th>
                  <th>Quantidade</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in equipes" :key="index">
                  <td>{{ item.name }}</td>
                  <td>
                    <validation-provider v-slot="{ errors }" rules="required">
                      <input type="text" v-model="item.quantity" />
                      <div class="error">{{ errors[0] }}</div>
                    </validation-provider>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-lg-12">
            <label for="">Classificação</label>
            <select v-model="form.classificacao">
              <option
                v-for="(item, index) in classificacaoOptions"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
          <div class="col-lg-12">
            <button @click="gerarRelatorio()">
              <b-spinner
                v-if="loading"
                label="Spinning"
                small
                variant="white"
              ></b-spinner>
              <span v-else> Verificar recursos</span>
            </button>
          </div>
        </div>
      </ValidationObserver>
      <div class="row">
        <div class="col-lg-12">
          <div class="response-openai" v-html="responseOpenAI"></div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import utils from '@/mixins/utils.js'
import axios from 'axios'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import { marked } from 'marked'

export default {
  name: 'VinculoAcompanhamentoRecursos',
  components: {
    Menu,
    Footer,
    SectionTitle,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [utils],
  metaInfo: {
    title: 'Recursos - Vínculo e acompanhamento',
    titleTemplate: null,
  },
  data() {
    return {
      classificacaoOptions: [
        {
          label: 'Ótimo',
          value: 'Ótimo',
        },
        {
          label: 'Bom',
          value: 'Bom',
        },
        {
          label: 'Suficiente',
          value: 'Suficiente',
        },
        {
          label: 'Regular',
          value: 'Regular',
        },
      ],
      form: {
        classificacao: 'Bom',
      },
      equipes: [
        { name: 'eSF 40h', quantity: '' },
        { name: 'eAP 20h', quantity: '' },
        { name: 'eAP 30h', quantity: '' },
      ],
      loading: false,
      responseOpenAI: '',
    }
  },
  computed: {},
  methods: {
    async gerarRelatorio() {
      this.$refs.observer.validate().then(async (success) => {
        if (!success) {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
          return
        }

        try {
          this.responseOpenAI = ''
          this.loading = true

          let templateTabela = `
            VALORES DO COMPONENTE DE VÍNCULO E ACOMPANHAMENTO TERRITORIAL
            Equipe; Modalidade;Ótimo; Bom; Suficiente; Regular
            eSF; 40h; R$ 8.000,00; R$ 6.000,00; R$ 4.000,00; R$ 2.000,00
            eAP; 30h; R$ 4.000,00; R$ 3.000,00; R$ 2.000,00; R$ 1.000,00
            eAP; 20h; R$ 3.000,00; R$ 2.250,00 ;R$ 1.500,00; R$ 750,00
          `
          let payload =
            'Analise os dados que estão delimitados por tripla crease e mostre a tabela de valores conforme classificação e tipo de equipe. Formatar no estilo markdown. Dados: ```' +
            templateTabela +
            ' ```'

          await this.getResultOpenAi(payload)

          // let templateEquipes = this.equipes
          //   .map((team) => `${team.name}: ${team.quantity}`)
          //   .join(', ')

          let payload2 = `Considerando a classificação ${this.form.classificacao} e a quantidade de: ${this.equipes[0].quantity} eSF 40h, ${this.equipes[1].quantity} eAP 20h e ${this.equipes[2].quantity} eAP 30h. Analise o os dados que estão delimitados por tripla crease e apresente o valor total por equipe, bem como o valor total considerando todas as equipes. Não exibir eSF ou eAP se a quantidade for 0. Formatar no estilo markdown.
          Dados: \`\`\`
          ${templateTabela}
          \`\`\``

          await this.getResultOpenAi(payload2)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      })
    },

    async getResultOpenAi(payload) {
      let apiKey = await this.$api.post('/app/utils/chatpgt', {
        co_ibge: this.$store.state.cod_ibge,
      })
      if (apiKey.data.error == false) {
        const response = await axios.post(
          'https://api.openai.com/v1/chat/completions',
          {
            model: 'gpt-3.5-turbo',
            messages: [{ role: 'user', content: payload }],
            temperature: 0.7,
          },
          {
            headers: {
              Authorization: `Bearer ${apiKey.data.apiKey}`,
            },
          }
        )
        if (response) {
          this.responseOpenAI += marked(
            response.data.choices[0].message.content,
            {
              sanitize: true,
            }
          )
        }
      }
    },
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
